/* eslint-disable */
class JwtUtils {
  /// Decode a string JWT token into an object
  /// containing the decoded JSON payload.
  ///
  /// Note: header and signature are not returned by this method.
  ///
  /// Throws Error if parameter is not a valid JWT token.
  static decode(token) {
    const splitToken = token.split(".");
    if (splitToken.length !== 3) {
      throw new Error("Invalid token");
    }

    try {
      const payloadBase64 = splitToken[1]; // Payload is always index 1

      // Normalize base64 (add padding if missing)
      const normalizedPayload = JwtUtils._normalizeBase64(payloadBase64);

      // Decode payload -> string
      const payloadString = Buffer.from(normalizedPayload, "base64").toString("utf8");

      // Parse into object
      const decodedPayload = JSON.parse(payloadString);

      return decodedPayload;
    } catch (error) {
      throw new Error("Invalid payload");
    }
  }

  /// Decode safely, returns null if token is invalid
  static tryDecode(token) {
    try {
      return JwtUtils.decode(token);
    } catch {
      return null;
    }
  }

  /// Tells whether a token is expired.
  /// Returns true if expired, false otherwise.
  static isExpired(token) {
    const expirationDate = JwtUtils.getExpirationDate(token);
    return new Date() > expirationDate;
  }

  /// Returns token expiration date
  static getExpirationDate(token) {
    const decodedToken = JwtUtils.decode(token);
    if (!decodedToken.exp) throw new Error("No exp in token");

    return new Date(decodedToken.exp * 1000); // exp is in seconds
  }

  /// Returns time elapsed since issue (iat)
  static getTokenTime(token) {
    const decodedToken = JwtUtils.decode(token);
    if (!decodedToken.iat) throw new Error("No iat in token");

    const issuedAtDate = new Date(decodedToken.iat * 1000);
    return new Date() - issuedAtDate; // milliseconds difference
  }

  /// Returns remaining time until expiry date (ms)
  static getRemainingTime(token) {
    const expirationDate = JwtUtils.getExpirationDate(token);
    return expirationDate - new Date();
  }

  /// Internal helper to normalize Base64 strings
  static _normalizeBase64(base64String) {
    let str = base64String.replace(/-/g, "+").replace(/_/g, "/");
    while (str.length % 4 !== 0) {
      str += "=";
    }
    return str;
  }
}

export default JwtUtils;

